export default __webpack_public_path__ + "static/media/landingBackground7Mobile.f9546d87.png";